// extracted by mini-css-extract-plugin
export default {"detailDescription":"ProductDescription_detailDescription__4UL8b"};